import axios from "axios"
import { getCars } from "./carsSlice";


export function carsGetAxios() {
        return async function carsGetThunk(dispatch, getState) {
            const response = await axios.get(`/api/cars`)
            dispatch(getCars(response.data));
        };
    }